import { useEffect, useState } from "react";
import BAMFull from "./BAMFull";
import { AdminProvider, AdminModeBadge } from "./shared/AdminContext";
import { OrgProvider } from "./shared/OrgContext";
import { AdminMetricsBar } from "./shared/AdminMetricsBar";
import { AnnouncementBanner } from "./shared/AnnouncementBanner";
import { DARK, LIGHT } from "./constants/theme";
import { resolveDarkMode, DARK_MODE_EVENT } from "./utils/darkMode";

export default function Dashboard() {
  // The announcement banner is mounted outside BAMFull, so it cannot read
  // BAMFull's theme state and has to work it out for itself.
  //
  // It used to do that with `localStorage.getItem("bam_dark_mode") === "1"`,
  // while BAMFull writes String(boolean). So the answer was "false" for
  // everyone in dark mode, and the banner rendered LIGHT over a dark app:
  // near-black text on a dark background. resolveDarkMode is now the only
  // place that question is answered.
  const [dark, setDark] = useState(resolveDarkMode);
  useEffect(() => {
    const onChange = () => setDark(resolveDarkMode());
    window.addEventListener(DARK_MODE_EVENT, onChange);
    // Another tab toggling the theme.
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener(DARK_MODE_EVENT, onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);
  const C = dark ? DARK : LIGHT;
  return (
    <AdminProvider>
      {/* OrgProvider is dormant for solo coaches (no memberships yet); it
          comes alive once Phase 1 wires the BAM Consulting checkout flow
          and starts populating organizations + org_members. Keeping the
          provider mounted from day one means org-aware components don't
          have to lazy-mount when consulting goes live. */}
      <OrgProvider>
        <AnnouncementBanner C={C} dark={dark}/>
        <BAMFull />
        <AdminModeBadge />
        <AdminMetricsBar />
      </OrgProvider>
    </AdminProvider>
  );
}

